import { useMemo } from 'react';
import { objType, updateInfoType } from 'types';
import { componentsStateType } from 'reducer/types';
import { deepLinkTarget } from 'utils/constants';


const dev              = process.env.NODE_ENV === 'development';
  

  const useShowLoader = (
    componentsState:    componentsStateType,
    dataUpdateState:    updateInfoType,
    groupLessonsState:  objType,
    userLessonsState:   objType,
    storageUpdateState: boolean,
    goToVideoOnce:      boolean,

    ) => {
  
  
    const [showLoader, showUpdatingLoader] = useMemo(() => {
  
      if ( dev ) {
        return [false, false]
      }
      
      return[
        (
           (!!deepLinkTarget && !dataUpdateState.content && !goToVideoOnce) ||
           groupLessonsState.showGroupLessonsLoader ||
           userLessonsState.showUserLessonsLoader ||
           (!dataUpdateState.final && !storageUpdateState)
        ),
       // ((!dataUpdateState.final && storageUpdateState) || (componentsState.showAppIntro && !dataUpdateState.scores))
        !dataUpdateState.final
      ]
    },[dataUpdateState, /*componentsState,*/ storageUpdateState, groupLessonsState, userLessonsState, goToVideoOnce, deepLinkTarget])
  
    return { showLoader, showUpdatingLoader }
  
}
  export default useShowLoader;
  